import { useData, useDispatch } from "./DataContext.js";

import ToggleButton from "react-bootstrap/ToggleButton";

import AmendmentCard from "./AmendmentCard.js";


export function filterAmendmentState (gData, params, amendment)
{
    // CHECK SIM AND DELETION
    if (amendment.simID !== params.simID || amendment.state === "deleted") return false;

    // CHECK AUTHORISATIONS
    if ((amendment.state === "draft") && amendment.groupID !== gData.groupID) return false;
    if (amendment.state === "waiting" && amendment.groupID !== gData.groupID && ! gData.admin) return false;
    
    // CHECK IF EDIT OR NEW ARTICLE
    if (! params.displayAll)
    {
	if (params.articleID === null)
	{
	    if (amendment.type !== "newArticle") return false;
	}

	else {
	    if (amendment.type === "newArticle") return false;
	    if (gData.article[amendment.articleID].firstArticleID !== gData.article[params.articleID].firstArticleID) return false;
	}
    }

    // CHECK STATE
    let state = amendment.state;
    if (state === "waiting") state = "draft";
    if (state === "canceled" || (state !== "accepted" && state !== "rejected" && amendment.sessionNum !== gData.sim[params.simID].sessionNum)) state = "archived";
    //if (state === "archived" && amendment.groupID !== gData.groupID) return false;

    return params.state === null || state === params.state;
}

export function sortAmendmentState (gData, params, amendment1, amendment2)
{
    // TODO: make this computation more global
    // TODO: for "waiting" sort in the opposite direction
    if (params.state === "draft" || params.state === "waiting" || params.state === "archived") return amendment2.creationTime.localeCompare(amendment1.creationTime);
    if (params.state === "submitted")
    {
	// ORDER BY ARTICLES
	const articleRank1 = amendment1.articleID !== null ? gData.article[amendment1.articleID].rank : Number.MAX_VALUE;
	const articleRank2 = amendment2.articleID !== null ? gData.article[amendment2.articleID].rank : Number.MAX_VALUE;
	if (articleRank1 !== articleRank2) return articleRank1 - articleRank2;

	// ORDER BY DELETION
	const deletion1 = amendment1.content.every((paragraph) => paragraph.trim() === "");
	const deletion2 = amendment2.content.every((paragraph) => paragraph.trim() === "");
	if (deletion1 && ! deletion2) return -1; else if (! deletion1 && deletion2) return 1;

	// ORDER BY SUPPORTS
	const voteCount1 = amendment1.supportIDS.reduce((voteCount, supportID) => voteCount + gData.group[supportID].voteCount, 0);
	const voteCount2 = amendment2.supportIDS.reduce((voteCount, supportID) => voteCount + gData.group[supportID].voteCount, 0);
	if (voteCount1 !== voteCount2) return voteCount2 - voteCount1;
	
	return amendment1.creationTime.localeCompare(amendment2.creationTime);
    }

    else return amendment2.rank - amendment1.rank;
}



export default function AmendmentList (props)
{
    const gData = useData();
    if (props.state === null) return (<></>);

    const state = props.state;
    const articleID = props.articleID;
    const displayAll = props.displayAll;

    const params = { state, articleID, simID: gData.simID, displayAll };

    const amendmentList = Object
	.entries(gData.amendment)
	.filter(([id, amendment]) => { return filterAmendmentState (gData, params, amendment); })
	.sort(([id1, amendment1], [id2, amendment2]) => { return sortAmendmentState (gData, params, amendment1, amendment2); })
	.map(([id, amendment]) => { return (<AmendmentCard key={amendment.amendmentID} amendmentID={amendment.amendmentID}/>); });
    // TODO: key = rank?

    // RENDER
    return (<div className="d-flex flex-column align-items-center gap-3">{amendmentList}</div>);
}

AmendmentList.defaultProps = {
    articleID: null
};


AmendmentList.Buttons = function Buttons (props)
{
    const gData = useData();
    const gDispatch = useDispatch();
    
    const states = props.states;
    const displayAll = props.displayAll;
    const articleID = props.articleID;

    let firstArticleID = null;
    if (articleID !== null) firstArticleID = gData.article[articleID].firstArticleID;
    
    const simID = props.simID === null ? gData.simID : props.simID;
    const params = { state: null, articleID, firstArticleID, simID, displayAll };

    function unsetAmendmentState () { gDispatch({ type: "unsetAmendmentState" }); }
    function setAmendmentState (state) { gDispatch({ type: "setAmendmentState", state, articleID, displayAll, amendmentID: null }); }

    const amendmentList = Object
	.entries(gData.amendment)
	.filter(([id, amendment]) => { return filterAmendmentState (gData, params, amendment); });

    const sessionNum = gData.sim[simID].sessionNum;
    const amendmentNb = amendmentList.reduce((nb, [id, amendment]) => {
	if (amendment.state !== "accepted" && amendment.state !== "rejected" && amendment.sessionNum !== sessionNum) nb["archived"]++;
	else if (amendment.state === "waiting") nb["draft"]++;
	else if (amendment.state === "canceled") nb["archived"]++;
	else nb[amendment.state]++;
	return nb;
    }, { draft: 0, submitted: 0, accepted: 0, rejected: 0, archived: 0 });

    const amendmentButtonList = [
	{ state: "draft", variant: "outline-secondary", singular: "rédigé", plural: "rédigés" },
	{ state: "submitted", variant: "outline-dark", singular: "déposé", plural: "déposés" },
	{ state: "accepted", variant: "outline-success", singular: "adopté", plural: "adoptés" },
	{ state: "rejected", variant: "outline-danger", singular: "rejeté", plural: "rejetés" },
	{ state: "archived", variant: "outline-secondary", singular: "archivé", plural: "archivés" }
    ]
	.filter((state) => { return states === undefined || states.includes(state.state); })
	.map((state) => {
	    const empty = amendmentNb[state.state] === 0;
	    const disabled = empty;
	    let stateFirstArticleID = null;
	    if (gData.amendmentState !== null && gData.amendmentState.articleID !== null) stateFirstArticleID = gData.article[gData.amendmentState.articleID].firstArticleID;
	    const checked = ! disabled && ! empty && gData.amendmentState !== null && state.state === gData.amendmentState.state && firstArticleID === stateFirstArticleID && gData.amendmentState.displayAll === displayAll;
	    
	    function handleToggleState (e)
	    {
		e.preventDefault();
		if (disabled) return;

		if (gData.amendmentState !== null && state.state === gData.amendmentState.state && firstArticleID === stateFirstArticleID && gData.amendmentState.displayAll === displayAll) unsetAmendmentState();
		else setAmendmentState(state.state);
	    }
	    
	    return (
		<ToggleButton
		    type="radio"
		    key={state.state}
		    variant={state.variant}
		    className={disabled ? "pe-none" : ""}
		    size={props.size}
		    checked={checked}
		    disabled={disabled}
		    onClick={handleToggleState}
		>
		    <span className="text-uppercase">{amendmentNb[state.state] + " " + (amendmentNb[state.state] > 1 ? state.plural : state.singular)}</span>
		</ToggleButton>
	    );
	});


    return amendmentButtonList;
    //return props.stateList.map((state) => { return (<AmendmentStateNb key={state} nb={amendmentNb[state]} state={state}/>); });
}

AmendmentList.Buttons.defaultProps = {
    simID: null,
    articleID: null,
    displayAll: false,
    disabled: false,
    size: "md"
};

